var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name !== 'login')?_c('keep-alive',{key:_vm.$store.state.sessionGeneration,attrs:{"include":"layout"}},[_c('router-view')],1):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }